export default __webpack_public_path__ + "512d2f68c98d2695f5e45f89f24607fa.svg";